var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desc"},[_c('div',{staticClass:"desc__text",domProps:{"innerHTML":_vm._s(_vm.cont)}}),_c('div',{ref:"descHtml",staticClass:"desc-html",staticStyle:{"display":"none"},domProps:{"innerHTML":_vm._s(_vm.desc)}})])}
var staticRenderFns = []

export { render, staticRenderFns }